import { ListModel } from '../../core/model/list.model';
import { Action } from '@ngrx/store';

//state
export interface ListState {
  no_contract: ListModel[];
  commerce_type: ListModel[];
  operation_year: ListModel[];
  legal_strucutre: ListModel[];
  owner: ListModel[];
  addressTime: ListModel[];
  bank: ListModel[];
  membershipTime: ListModel[];
}

export const LIST_STATE_INIT: ListState = {
  no_contract: [
    { value: 0, label: 'Selecciona' },
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
  ],
  commerce_type: [
    { value: 0, label: 'Selecciona' },
    { value: 1, label: 'Restaurante' },
    { value: 2, label: 'Taller Mecanico' },
    { value: 3, label: 'Salón de Belleza' },
    { value: 4, label: 'Hotel' },
    //{ value: 5, label: 'Motel' },
    //{ value: 6, label: 'Bar' },
    //{ value: 7, label: 'Licoleria' },
    { value: 8, label: 'Dentista' },
    { value: 9, label: 'Tienda Minorista' },
    { value: 10, label: 'Floreria' },
    { value: 11, label: 'Empresa de Limpieza' },
    //{ value: 12, label: 'Otro' },
    // { value: 1, label: 'Agencias automotrices' },
    // { value: 2, label: 'Centros educativos' },
    // { value: 3, label: 'Clínica Médica' },
    // { value: 4, label: 'Consultorio Médico' },
    // { value: 10, label: 'Tienda' },
    // { value: 11, label: 'Tintorerías' },
  ],
  operation_year: [
    { value: 0, label: 'Selecciona' },
    { value: 1, label: 'Menos de 6 meses ' },
    { value: 2, label: 'Entre 6 meses y 1 año' },
    { value: 3, label: 'Entre 1 y 2 años ' },
    { value: 4, label: 'Entre 2 y 3 años' },
    { value: 5, label: 'Entre 3 y 4 años' },
    { value: 6, label: 'Entre 4 y 5 años' },
    { value: 7, label: 'Más de 5 años' },
    { value: 8, label: 'Más de 10 años' },
    { value: 9, label: 'Más de 15 años' },
  ],
  legal_strucutre: [
    { value: 0, label: 'Selecciona' },
    { value: 1, label: 'Persona Física con Actividad Empresarial' },
    { value: 2, label: 'Persona Moral' },
  ],
  owner: [
    { value: 0, label: 'Selecciona' },
    { value: 1, label: 'Propio' },
    { value: 2, label: 'Rentado' },
    { value: 3, label: 'otro' },
  ],
  addressTime: [
    { value: 0, label: 'Selecciona' },
    { value: 1, label: 'Menos de 1 año' },
    { value: 2, label: '1 año' },
    { value: 3, label: '2 años' },
    { value: 4, label: '3 años' },
    { value: 5, label: '4 años' },
    { value: 6, label: '5 años' },
    { value: 7, label: 'Mas de 5 años' },
  ],
  bank: 
  [
    { value: 0, label: 'Selecciona' },
    { value: 1, label: 'BBVA Bancomer (Personal)' },
    { value: 2, label: 'Banamex Empresas' },
    { value: 3, label: 'Santander' },
    { value: 4, label: 'HSBC' },
    { value: 5, label: 'Banorte (Personal)' },
    { value: 6, label: 'Afirme' },
    { value: 7, label: 'American Express' },
    { value: 8, label: 'BanCoppel' },
    { value: 9, label: 'Banco Azteca' },
    { value: 10, label: 'Banco Famsa' },
    { value: 11, label: 'Banregio' },
    { value: 12, label: 'Inbursa' },
    { value: 13, label: 'Invex' },
    { value: 14, label: 'Liverpool' },
    { value: 15, label: 'Banco Multiva' },
    { value: 16, label: 'BBVA Bancomer (Corporativo)' },
    { value: 17, label: 'BBVA Bancomer (Empresas)' },
    { value: 18, label: 'Banorte (Empresa)' },
    { value: 19, label: 'Banbajio Personal'  },
    { value: 20, label: 'Banamex Personal' },
    { value: 999, label: 'SAT' },
  ],

  membershipTime: [
    { value: 0, label: 'Selecciona' },
    { value: 1, label: 'Menor a 1 año' },
    { value: 2, label: 'Entre 1 y 2 años' },
    { value: 3, label: 'Entre 2 y 3 años' },
    { value: 4, label: 'Entre 3 y 5 años' },
    { value: 5, label: 'Entre 5 y 7 años' },
    { value: 6, label: 'Entre 7 y 10 años' },
    { value: 7, label: 'Más de 10 años' },
  ]
}

//{ value: 0, label: '' },


//reducer
export function listReducer(state: ListState = LIST_STATE_INIT, action: Action): ListState {
  switch (action.type) {
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/store/list/index.ts